import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Kiosk from '../Kiosk.vue'

const routes = [
  { path: '/:placeContextId/:kioskToken', name: 'kiosk', component: Kiosk }
]

export default new VueRouter({
    mode: 'history',
    routes
})
